/* eslint-disable no-console */
import getLogLevels from "./getLogLevels";
import getMaxLogLevel from "./getMaxLogLevel";

const getLibLoggerForLevel = (level, index, lib) => (...args) => {
  const shouldLog = SERVER || process.env.NODE_ENV === "development";
  const logLevels = getLogLevels();
  const maxLogLevel = getMaxLogLevel();

  if (index > logLevels[maxLogLevel]) return false;

  return shouldLog && lib === console
    ? console.log(...[new Date().toString(), level.toUpperCase(), ...args])
    : lib[level](...args);
};

export default getLibLoggerForLevel;
